exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".step[data-v-c5f03f92]{background-color:#3c3c3c;border-radius:5px;display:flex;margin:10px;padding-top:10px}.step .stepNumber[data-v-c5f03f92]{display:flex;justify-content:center;margin-top:20px;margin-left:12px;font-size:40px;color:#ccc;border-radius:5px;width:45px}.stepTransitions[data-v-c5f03f92]{flex:1;display:flex;flex-wrap:wrap}@media only screen and (max-width:768px){.step[data-v-c5f03f92]{flex-direction:column;align-items:center;padding-top:5px}.step .stepNumber[data-v-c5f03f92]:before{content:\"Step\";padding-right:5px}.step .stepNumber[data-v-c5f03f92]{padding:0;margin:0;margin-bottom:5px;font-size:16px;font-weight:700;color:inherit}.stepTransitions[data-v-c5f03f92]{align-items:center;justify-content:center}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-c5f03f92","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/RecipeStep.vue
// module id = 94
// module chunks = 0